import { observer } from 'mobx-react';
import * as React from 'react';
import { IconType } from '@react-icons/all-files/lib';

export interface IInputMultiSelectFiltersProps<TViewModel> {
    readonly filtersMeta: IInputMultiSelectFiltersMeta<TViewModel>[];
    readonly vm: TViewModel;
    readonly isInForm?: boolean;
}

@observer
export class InputMultiSelectFilters<TViewModel> extends React.Component<IInputMultiSelectFiltersProps<TViewModel>> {
    public render() {
        const { filtersMeta, vm } = this.props;

        return filtersMeta.map(meta => meta.render({ vm }));
    }
}

export interface IInputMultiSelectFilterProps<TViewModel> {
    readonly vm: TViewModel;
}

export interface IInputMultiSelectFiltersMeta<TViewModel> {
    shouldRender(vm: TViewModel): void;
    render(props: IInputMultiSelectFilterProps<TViewModel>): JSX.Element;
    readonly id: string;
    readonly title: string;
    readonly icon: React.ReactNode;
}
